import { render, staticRenderFns } from "./PlaylistsList.vue?vue&type=template&id=3b4964e8&scoped=true&"
import script from "./PlaylistsList.vue?vue&type=script&lang=js&"
export * from "./PlaylistsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4964e8",
  null
  
)

export default component.exports